export class ControlViolation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "muted",
            "baseName": "muted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "control",
            "baseName": "control",
            "type": "Control",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlViolation.attributeTypeMap;
    }
    constructor() {
    }
}
